export default __webpack_public_path__ + "images/0xc00e94cb662c3520282e6f5717214004a7f26888.png";